interface IPricePerPeriodProps {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

const PricePerPeriod: React.FC<IPricePerPeriodProps> = ({
  children,
  UNSAFE_className = '',
}) => {
  return (
    <span
      className={`tw-lf-title-sm tw-mb-1 tw-whitespace-pre-line desktop:tw-lf-title-lg ${UNSAFE_className}`}
    >
      {children}
    </span>
  );
};

export default PricePerPeriod;
